import * as types from './types';

export const showConfirmModal = (modalType, props) => ({
  type: types.SHOW_CONFIRM_MODAL,
  payload: {
    modalType,
    props,
  },
});

export const hideConfirmModal = () => ({
  type: types.HIDE_CONFIRM_MODAL,
});
